<div *ngIf="prikaziStranicu" class="container-fluid">
  <h2 class="content-block">NARUDŽBE</h2>

  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box
          [(value)]="datumOd"
          [(max)]="datumDo"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumOd($event)">
        </dx-date-box>
      </div>

      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box
          [(value)]="datumDo"
          [(min)]="datumOd"
          pickerType="calendar"
          displayFormat='dd.MM.yyyy.'
          width="200"
          (onValueChanged)="onValueChangedDatumDo($event)">
        </dx-date-box>
      </div>

      <div class="odabirDatuma" style="margin-left: 30px">
        <div class="selectDropdown">
          <label>Vrsta:</label>
          <dx-select-box
            [disabled]="false"
            [items]="arrayVrsta"
            [value]="arrayVrsta[0].vrijednost"
            valueExpr="vrijednost"
            displayExpr="naziv"
            [width]="150"
            (onValueChanged)="promjenaVrste($event)">
          </dx-select-box>
        </div>
      </div>

      <div class="odabirDatuma" style="margin-left: 30px">
        <div class="selectDropdown">
          <label>Firma:</label>
          <dx-select-box
            [disabled]="false"
            [items]="arrayFirma"
            [value]="firma"
            valueExpr="vrijednost"
            displayExpr="naziv"
            [width]="200"
            (onValueChanged)="promjenaFirme($event)">
          </dx-select-box>
        </div>
      </div>

      <div class="odabirDatuma">
        <dx-button
          class="btn_trazi"
          [disabled]="disableGumb"
          stylingMode="contained"
          text="Prikaži"
          type="success"
          [width]="120"
          (onClick)="pretrazi()">
        </dx-button>
      </div>
    </div>

    <div class="customTable dnevniPlan">
      <dx-data-grid
        id="tablicaNarudzba"
        [dataSource]="narudzbe"
        [wordWrapEnabled]="true"
        noDataText="{{ poruka }}"
        keyExpr="do_id"
        [showBorders]="false"
        [columnAutoWidth]="true"
        [columnMinWidth]="60"
        [showColumnLines]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onRowClick)="onRowClick($event)"
        (onRowUpdated)="urediNarudzbu($event)"
        (onCellPrepared)="onCellPrepared($event)"
      >
        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov">
            <h2 class="mb-0">Narudžbe</h2>
            <p class="mt-0">Kliknite na narudžbu za prikaz detalja</p>
          </div>
        </div>

        <dxo-header-filter [visible]="true"></dxo-header-filter>

        <dxo-scrolling
          columnRenderingMode="virtual"
          [showScrollbar]="'always'"
        ></dxo-scrolling>

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>

        <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>

        <dxo-pager
          [showPageSizeSelector]="true"
          [allowedPageSizes]="[10, 20, 30]"
          [showInfo]="true"
        >
        </dxo-pager>

        <dxo-selection mode="single"></dxo-selection>

        <dxo-editing 
          mode="popup" 
          [allowAdding]="false"
          [allowUpdating]="dozvoliUredivanje"
          [allowDeleting]="false">
          
          <dxo-popup
            [disabled]="pravaZaTrenutniPogled != 2"
            [showTitle]="true"
            title="Uređivanje narudžbe"
            [maxWidth]="500"
            [height]="'auto'">
          </dxo-popup>

          <dxo-form [colCount]="1">
            <dxi-item dataField="do_zautovar"></dxi-item>
            <dxi-item
              dataField="poslovnicapartnera_pp_idTomo"
              editorType="dxSelectBox"
              [editorOptions]="{
                items: poslovniceTomo,
                value: 'pp_id',
                valueExpr: 'pp_id',
                displayExpr: 'sifrainaziv',
                searchEnabled: 'true',
                searchExpr: ['pp_sifra', 'pp_naziv'],
                showClearButton: 'true'
              }">
            </dxi-item>
          </dxo-form>
        </dxo-editing>

        <dxi-column
          dataField="do_id"
          caption="Broj narudžbe"
          [width]="160"
          alignment="center"
          [allowFiltering]="true"
          [allowEditing]="false"
        ></dxi-column>

        <dxi-column
          dataField="do_brojnarudzbe"
          caption="Broj narudžbe kupca"
          [width]="210"
          alignment="center"
          [allowFiltering]="true"
          [allowEditing]="false"
        ></dxi-column>

        <dxi-column
          [(visible)]="isRazlikaVisible"
          dataField="razlika">
        </dxi-column>

        <dxi-column caption="Povezani dokumenti" cellTemplate="cellLink" [width]="100" alignment="center">
          <div *dxTemplate="let data of 'cellLink'">
            <dx-button hint="Povezani dokumenti" icon="link" (onClick)="povezaniDokumenti(data)"></dx-button>
          </div>
        </dxi-column>

        <!-- <dxi-column
          dataField="broj_dostavnice"
          caption="Broj dostavnice"
          [width]="160"
          alignment="center"
          [allowFiltering]="false"
          [allowEditing]="false"
        ></dxi-column>

        <dxi-column
          dataField="broj_otpremnice_pekar"
          caption="Broj otpremnice"
          [width]="160"
          alignment="center"
          [allowFiltering]="false"
          [allowEditing]="false"
        ></dxi-column> -->

        <dxi-column
          dataField="datum_narudzbe"
          dataType="date"
          caption="Datum narudžbe"
          [width]="180"
          alignment="center"
        ></dxi-column>

        <dxi-column
          dataField="do_datumizrade"
          dataType="date"
          caption="Datum kreiranja narudžbe"
          [width]="180"
          alignment="center"
        ></dxi-column>

        <dxi-column
          dataField="pa_naziv"
          caption="Partner"
        ></dxi-column>

        <dxi-column
          dataField="pp_naziv"
          caption="Poslovnica partnera"
        ></dxi-column>

        <dxi-column dataField="do_zautovar" caption="Za utovar" alignment="center" [width]="140">
          <dxo-lookup
            [dataSource]="arrayZautovar"
            displayExpr="ut_naziv"
            valueExpr="vrijednost">
          </dxo-lookup>
        </dxi-column>

        <dxi-column
          dataField="poslovnicapartneraOtpremeTomo"
          caption="Skladište otpreme Tomo"
          [minWidth]="200"
        ></dxi-column>

        <dxi-column
          dataField="poslovnicapartnera_pp_idTomo"
          caption="Skladište otpreme Tomo"
          [minWidth]="200"
          [visible]="false"
        ></dxi-column>

        <dxi-column dataField="do_obradjena" caption="Obrađena" alignment="center" [width]="140">
          <dxo-lookup
            [dataSource]="arrayObradena"
            displayExpr="ob_naziv"
            valueExpr="vrijednost">
          </dxo-lookup>
        </dxi-column>

        <dxi-column caption="PDF" cellTemplate="ispis" alignment="center" [fixed]="true" fixedPosition="right">
          <div *dxTemplate="let data of 'ispis'">
            <dx-button
              [disabled]="pravaZaTrenutniPogled != 2"
              icon="pdffile"
              (onClick)="pdfNarudzba(data)">
            </dx-button>
          </div>
        </dxi-column>

        <dxi-column *ngIf="prikaziOtpremnicu" caption="Otpremnica" cellTemplate="cellOtpremnica" alignment="center" [fixed]="true" fixedPosition="right"></dxi-column>
          <div *dxTemplate="let data of 'cellOtpremnica'">
            <dx-button
              [disabled]="data.data.do_obradjena == 1 || pravaZaTrenutniPogled != 2"
              icon="add"
              (onClick)="kreirajOtpremnicu(data)">
            </dx-button>
          </div>

        <dxi-column
          dataField="do_vrijemeoznakezautovar"
          dataType="datetime"
          caption="Datum i vrijeme izmjene"
          [width]="200"
          alignment="center"
        ></dxi-column>

        <dxo-master-detail
          [enabled]="false"
          template="detail">
        </dxo-master-detail>
        <div *dxTemplate="let data of 'detail'">
          <!-- <p *ngIf="!stavke">Dohvaćanje stavki...</p>
          <p *ngIf="stavke.length === 0">Nema stavki!</p>
          <div *ngIf="stavke.length > 0"> -->
          <div *ngIf="isLoading" class="content-block">Učitavanje tablice...</div>
          <div *ngIf="!isLoading">
            <div class="classStavke">
              <dx-data-grid
                [dataSource]="stavke"
                [wordWrapEnabled]="true"
                keyExpr="artikl_id"
                (onRowPrepared)="onRowPrepared($event)"
                [showBorders]="true">

                <dxi-column
                  dataField="ar_sifra"
                  caption="Šifra"
                  [width]="120">
                </dxi-column>
                <dxi-column
                  dataField="ar_naziv"
                  caption="Naziv"
                  [width]="500">
                </dxi-column>
                <dxi-column
                  dataField="naruceno"
                  caption="Naručeno"
                  [width]="200"
                  alignment="right">
                </dxi-column>
                <dxi-column
                  dataField="isporuceno"
                  caption="Isporučeno"
                  [width]="200"
                  alignment="right">
                </dxi-column>
                <dxi-column
                  dataField="razlika"
                  caption="Razlika"
                  [width]="200"
                  alignment="right">
                </dxi-column>
              </dx-data-grid>
            </div>
          </div>
        </div>

        <div *dxTemplate="let data of 'sve'">
          <dx-button [ngClass]="[ aktivnoBtn ? 'startAktivni' : 'aktivni' ]" text="SVE" name="sve" (onClick)="sve()"></dx-button>  
        </div>
        <div *dxTemplate="let data of 'razlika'">
          <dx-button [ngClass]="[ aktivnoBtn ? 'neaktivni' : 'startNeaktivni' ]"  text="RAZLIKA" name="razlika" (onClick)="razlika()"></dx-button>  
        </div> 
        <div *dxTemplate="let data of 'pdfrazlika'">
          <dx-button *ngIf="sveNarudzbe == 0" text="PDF RAZLIKA" icon="exportpdf" name="pdfrazlika" (onClick)="generirajSveNarudzbePdf()"></dx-button>  
        </div> 

      </dx-data-grid>
    </div>
  </div>
</div>

<dx-popup
  [title]="naslov"
  [showTitle]="true"
  [width]="1000"
  [height]="'auto'"
  [closeOnOutsideClick]="false"
  [showCloseButton]="true"
  [(visible)]="povezaniDokumentiPopup"
  [position]="{ my: 'center', at: 'center', of: window }">

  <dx-data-grid
    id="tablicaPovezaniDokumenti"
    [dataSource]="povezani_dokumenti"
    [showColumnLines]="true"
    [wordWrapEnabled]="true"
    [showBorders]="false">
    <dxo-paging [enabled]="true" [pageSize]="10"></dxo-paging>
    <dxi-column
      dataField="pz_broj"
      caption="Broj"
      [width]="100" 
      alignment="right">
    </dxi-column>
    <dxi-column
      dataField="DV_NAZIV"
      caption="Vrsta"
      alignment="center">
    </dxi-column>
    <dxi-column
      dataField="pz_datum"
      dataType="date" 
      caption="Datum"
      [width]="130"
      alignment="center">
    </dxi-column>
    <dxi-column
      dataField="fi_naziv"
      caption="Firma">
    </dxi-column>
    <dxi-column
      dataField="po_naziv"
      caption="Naziv skladišta">
    </dxi-column>
  </dx-data-grid>
  <br>
  <dxi-item class="btn_group">
    <dx-button stylingMode="contained" [height]="40" [width]="120" type="success" (onClick)="uredu()">UREDU</dx-button><br><br>
  </dxi-item>
</dx-popup>